import { render, staticRenderFns } from "./CreateReward.vue?vue&type=template&id=dcaf7d7c&"
import script from "./CreateReward.vue?vue&type=script&lang=js&"
export * from "./CreateReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports